<div class="container">
  <h1>{{'SECTIONS.NOT_FOUND.OOPS' | translate}}</h1>
  <h4>{{'SECTIONS.NOT_FOUND.404' | translate}}</h4>
  <a [routerLink]="['']" class="app-btn">{{'SECTIONS.NOT_FOUND.GO_HOME' | translate}}</a>
</div>
